import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, ElementRef, EventEmitter, OnDestroy, OnInit, QueryList, ViewContainerRef } from '@angular/core';
import { KEYS, TreeComponent } from 'angular-tree-component';
import { ESRI } from '../../../esri-loader-util';
import { InputConverter } from '../../../inputConverter';
import { LayerService } from '../../../services/layer.service';
import { BaseComponent } from '../../base.component';
var limitRows = 5;
var resizeWait = 50;
var LegendComponent = /** @class */ (function (_super) {
    tslib_1.__extends(LegendComponent, _super);
    function LegendComponent(_vcr, layerService, changeDetectorRef) {
        var _this = _super.call(this, _vcr) || this;
        _this.layerService = layerService;
        _this.changeDetectorRef = changeDetectorRef;
        _this.optionSelectedEvent = new EventEmitter();
        _this.groupOptionSelectedEvent = new EventEmitter();
        _this.onsymbolchange = new EventEmitter();
        _this.showLayerDetail = true;
        _this.layerOptions = [];
        _this.readonly = false;
        _this.toggleBreakDetail = function (layerId) {
            var node = _this.findLayerInNodes(layerId, _this.nodes);
            if (node) {
                _this.toggleBreakDetail(node);
            }
        };
        _this.removeGroup = function (groupLayerId) {
            var groupLayer = _this.layerService.mapRef.findLayerById(groupLayerId);
            if (groupLayer) {
                _this.layerService.mapRef.remove(groupLayer);
                _this.refreshTree();
            }
        };
        _this.refreshTree = function (detectChangesBeforeTreeCreation) {
            if (detectChangesBeforeTreeCreation === void 0) { detectChangesBeforeTreeCreation = false; }
            var e_1, _a, e_2, _b;
            _this.nodes = [];
            if (detectChangesBeforeTreeCreation) {
                _this.changeDetectorRef.detectChanges();
            }
            var layers = _this.getLegendLayers();
            try {
                for (var layers_1 = tslib_1.__values(layers), layers_1_1 = layers_1.next(); !layers_1_1.done; layers_1_1 = layers_1.next()) {
                    var layer = layers_1_1.value;
                    if (layer.type === 'group') {
                        var groupParent = layer.layers.length ? layer.layers.getItemAt(0).mapcoreProps.groupParent : { groupId: layer.id, name: layer.title };
                        var groupNode = _this.createGroupNode(groupParent, layer.layers.some(function (sl) { return sl.visible; }));
                        try {
                            for (var _c = tslib_1.__values(layer.layers.toArray().reverse()), _d = _c.next(); !_d.done; _d = _c.next()) {
                                var childLayer = _d.value;
                                _this.createLeafNode(childLayer, groupNode);
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                    }
                    else {
                        _this.createLeafNode(layer, _this.nodes);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (layers_1_1 && !layers_1_1.done && (_a = layers_1.return)) _a.call(layers_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            _this.setParentNodesCheckboxBasedOnChildren(_this.nodes);
            _this.changeDetectorRef.detectChanges();
            _this.triggerLayerNameUpdates();
        };
        _this.setHorizontalFormat = function () {
            var treeElement = _this.getElementByIdWithShadowRoots('legendTree');
            var style = document.createElement('style');
            //set format to horizontal flex layout, remove the reorder icons, prevent text wrapping
            style.textContent = "tree-root tree-viewport > div .angular-tree-component > tree-node-collection > div {\n                                display: flex; /* Example style to make the element horizontal */\n                                flex-direction: row;\n                                align-items: center;\n                            }\n                            .legend-box .reorder {\n                                display: none;\n                            }\n                            .legend-box .content {\n                                margin-left: 0px;\n                                margin-right: 5px;\n                                display: flex;\n                                flex-wrap: nowrap;\n                                align-items: center;\n                                flex-grow: 1;\n                                position: relative;\n                            }\n                            .layer-name {\n                                width: auto;\n                                border: none;\n                                margin: 0;\n                                padding: 2px 17px 2px 2px;\n                                background: transparent;\n                                box-shadow: none;\n                                line-height: 19px;\n                                flex: 1 1 0;\n                                resize: vertical;\n                                min-height: 19px;\n                                white-space: nowrap;\n                            }\n                            tree-node-drop-slot {\n                                display:none;\n                            }\n                            tree-root tree-viewport > div .angular-tree-component > tree-node-collection > div > tree-node > div > tree-node-wrapper > .node-wrapper {\n                                display: flex;\n                                align-items: center;\n                            }\n                            .tree-node {\n                                border-bottom: none\n                            }\n                            .angular-tree-component {\n                                cursor: auto;\n                                line-height: 12px;\n                            }\n                            tree-node-expander {\n                                width: 10px;\n                                align-self: center;\n                                line-height: 0;\n                            }\n                            ";
            if (treeElement) {
                treeElement.appendChild(style);
            }
        };
        _this.collapseAll = function () {
            var treeElement = _this.getElementByIdWithShadowRoots('legendTree');
            var expandedLegendItems = treeElement.querySelectorAll('.toggle-children-wrapper-expanded');
            expandedLegendItems.forEach(function (item) {
                item.click();
            });
        };
        _this.registerEvent('optionSelectedEvent', _this.optionSelectedEvent);
        _this.registerEvent('onsymbolchange', _this.onsymbolchange);
        layerService.layersRefreshed.subscribe(function () {
            _this.refreshTree();
        });
        return _this;
    }
    Object.defineProperty(LegendComponent.prototype, "itemOptions", {
        set: function (itemOptions) {
            var _this = this;
            if (this.legendOptions.nativeElement.assignedNodes().length > 0) {
                itemOptions.forEach(function (item) {
                    var e_3, _a;
                    var itemEl = item.nativeElement;
                    itemEl.innerHTML = _this.legendOptions.nativeElement.assignedNodes()[0].outerHTML;
                    // value of -1 means that element is a group node and shouldn't trigger event
                    if (itemEl.attributes[0].value !== '-1') {
                        try {
                            for (var _b = tslib_1.__values(Array.from(itemEl.children)), _c = _b.next(); !_c.done; _c = _b.next()) {
                                var child = _c.value;
                                var eventDetails = {
                                    target: child,
                                    layerId: itemEl.getAttribute('uniqueLayerId')
                                };
                                child.dispatchEvent(new CustomEvent('attached', { detail: eventDetails, bubbles: true, composed: true }));
                            }
                        }
                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_3) throw e_3.error; }
                        }
                    }
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LegendComponent.prototype, "groupOptions", {
        set: function (groupOptions) {
            var _this = this;
            if (this.legendGroupOptions.nativeElement.assignedNodes().length > 0) {
                groupOptions.forEach(function (item) {
                    var e_4, _a;
                    var itemEl = item.nativeElement;
                    itemEl.innerHTML = _this.legendGroupOptions.nativeElement.assignedNodes()[0].outerHTML;
                    try {
                        for (var _b = tslib_1.__values(Array.from(itemEl.children)), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var child = _c.value;
                            var eventDetails = {
                                target: child,
                                layerId: itemEl.getAttribute('uniqueGroupId')
                            };
                            child.dispatchEvent(new CustomEvent('attached', { detail: eventDetails, bubbles: true, composed: true }));
                        }
                    }
                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_4) throw e_4.error; }
                    }
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LegendComponent.prototype, "hiddenLayers", {
        get: function () {
            return this.layerService.mapRef.layers.toArray().filter(function (l) { return l.mapcoreProps.hideInLegend; });
        },
        enumerable: true,
        configurable: true
    });
    LegendComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = this;
                        return [4 /*yield*/, ESRI.SymbolUtils];
                    case 1:
                        _b.SymbolUtils = _c.sent();
                        this.options = {
                            allowDrag: true,
                            allowDrop: function (element, to) {
                                // return true / false based on element, to.parent, to.index. e.g.
                                if (element === undefined || to.index < 0) {
                                    return false;
                                }
                                return true;
                            },
                            actionMapping: {
                                mouse: {
                                    click: null,
                                    dragStart: function (_tree, _node, e) {
                                        var cancel = function (event) {
                                            event.cancelBubble = true;
                                            event.preventDefault();
                                            event.stopPropagation();
                                            return false;
                                        };
                                        var reorderHandle = e.composedPath()[0].getElementsByClassName('reorder')[0];
                                        if (reorderHandle) {
                                            var bounds = reorderHandle.getBoundingClientRect();
                                            if (!(e.x > bounds.left && e.y > bounds.top && e.x < bounds.right && e.y < bounds.bottom)) {
                                                cancel(e); // Cancel if mouse isn't over the reorder handle
                                            }
                                        }
                                        else {
                                            cancel(e); // Cancel if there is no reorder handle
                                        }
                                    },
                                    drop: function (_tree, toNode, e, fromTo) {
                                        var layer = _this.layerService.getEsriLayerByUniqueId(fromTo.from.data.id);
                                        var to = fromTo.to.dropOnNode ? toNode : fromTo.to;
                                        var dropPosition;
                                        if (fromTo.to.dropOnNode) {
                                            var dropTargetBounding = e.currentTarget.getBoundingClientRect();
                                            dropPosition = (e.y - dropTargetBounding.y) < (dropTargetBounding.height / 2) ? 'above' : 'below';
                                        }
                                        else {
                                            dropPosition = 'on';
                                        }
                                        if ((dropPosition === 'above' && fromTo.from.index > to.index) || dropPosition === 'below') {
                                            to.index++;
                                        }
                                        if (to.parent && to.parent.data.nodeType === 'group') {
                                            // Is dropping on group layer
                                            var groupLayer = _this.layerService.getEsriLayerByUniqueId(to.parent.data.id);
                                            if (groupLayer.layers.find(function (l) { return l.id === layer.id; })) {
                                                // Layer is in group
                                                var toIndex = groupLayer.layers.length - to.index; // ESRI's layer order is reversed, so we need to reverse the index
                                                if ((dropPosition === 'on' && fromTo.from.index > to.index) || (dropPosition === 'below' && fromTo.from.index > to.index)) {
                                                    toIndex--;
                                                }
                                                groupLayer.layers.reorder(layer, toIndex);
                                                _this.refreshTree();
                                            }
                                        }
                                        else if (!layer.mapcoreProps.groupParent) {
                                            // layer is not in a group
                                            var toIndex = _this.layerService.mapRef.layers.length - (to.index + _this.hiddenLayers.length); // ESRI's layer order is reversed, so we need to reverse the index
                                            if ((dropPosition === 'on' && fromTo.from.index > to.index) || (dropPosition === 'below' && fromTo.from.index > to.index)) {
                                                toIndex--;
                                            }
                                            _this.layerService.mapRef.reorder(layer, toIndex);
                                            _this.refreshTree();
                                        }
                                    }
                                },
                                keys: (_a = {},
                                    _a[KEYS.RIGHT] = null,
                                    _a[KEYS.LEFT] = null,
                                    _a[KEYS.DOWN] = null,
                                    _a[KEYS.UP] = null,
                                    _a[KEYS.SPACE] = null,
                                    _a[KEYS.ENTER] = null,
                                    _a)
                            }
                        };
                        this.nodes = [];
                        return [2 /*return*/];
                }
            });
        });
    };
    LegendComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this;
                        if (!this.mapViewRef) return [3 /*break*/, 1];
                        _b = this.mapViewRef;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.setupMapViewRef(this.mapViewRef)];
                    case 2:
                        _b = _c.sent();
                        _c.label = 3;
                    case 3:
                        _a.mapViewRef = _b;
                        this.getMapLayerList();
                        this.isReady();
                        this.triggerLayerNameUpdates();
                        window.addEventListener('layerUpdatingChange', function (e) {
                            var node = _this.getNodeByESRIId(e.detail.layerId);
                            if (node) {
                                node.loading = e.detail.updating;
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    LegendComponent.prototype.findLayerInNodes = function (layerId, nodes) {
        var retVal = nodes.find(function (n) { return n.data.id === layerId; });
        if (!retVal) {
            var children = nodes.map(function (n) { return n.data.children; }).flat();
            if (children.length) {
                retVal = this.findLayerInNodes(layerId, children);
            }
        }
        return retVal;
    };
    LegendComponent.prototype.removeLayers = function (children) {
        var e_5, _a;
        try {
            for (var children_1 = tslib_1.__values(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
                var childNode = children_1_1.value;
                if (childNode.children) {
                    this.removeLayers(childNode.children);
                }
                this.mapViewRef.map.remove(childNode.layerData.parent);
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (children_1_1 && !children_1_1.done && (_a = children_1.return)) _a.call(children_1);
            }
            finally { if (e_5) throw e_5.error; }
        }
    };
    LegendComponent.prototype.toggleLayerDetails = function (node) {
        node.data.showDetails = !node.data.showDetails;
        this.changeDetectorRef.detectChanges();
    };
    LegendComponent.prototype.triggerLayerNameUpdates = function () {
        var _this = this;
        if (this.legendTree) {
            var element = this.legendTree.viewportComponent.elementRef.nativeElement;
            setTimeout(function (el) {
                var e_6, _a;
                var textareas = Array.from(el.getElementsByTagName('textarea')).filter(function (e) { return e.classList.contains('layer-name'); });
                try {
                    for (var textareas_1 = tslib_1.__values(textareas), textareas_1_1 = textareas_1.next(); !textareas_1_1.done; textareas_1_1 = textareas_1.next()) {
                        var textarea = textareas_1_1.value;
                        _this.recalcuateRows(textarea);
                    }
                }
                catch (e_6_1) { e_6 = { error: e_6_1 }; }
                finally {
                    try {
                        if (textareas_1_1 && !textareas_1_1.done && (_a = textareas_1.return)) _a.call(textareas_1);
                    }
                    finally { if (e_6) throw e_6.error; }
                }
            }, resizeWait, element);
        }
    };
    LegendComponent.prototype.check = function (node, checked) {
        this.updateChildNodeCheckbox(node, checked);
        this.updateParentNodeCheckbox(node.realParent);
        this.changeDetectorRef.detectChanges();
        this.layerService.layersRefreshed.emit();
    };
    LegendComponent.prototype.updateChildNodeCheckbox = function (node, checked) {
        var _this = this;
        this.updateLayerVisible(node.data.id, checked);
        node.data.checked = checked;
        if (node.children) {
            node.children.forEach(function (child) { return _this.updateChildNodeCheckbox(child, checked); });
            this.changeDetectorRef.detectChanges();
        }
    };
    LegendComponent.prototype.updateParentNodeCheckbox = function (node) {
        var e_7, _a;
        if (!node || !node.data || !node.data.name) {
            return;
        }
        var allChildrenChecked = true;
        var noChildChecked = true;
        try {
            for (var _b = tslib_1.__values(node.children), _c = _b.next(); !_c.done; _c = _b.next()) {
                var child = _c.value;
                if (!child.data.checked || child.data.indeterminate) {
                    allChildrenChecked = false;
                }
                if (child.data.checked) {
                    noChildChecked = false;
                }
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_7) throw e_7.error; }
        }
        if (allChildrenChecked) {
            node.data.checked = true;
            node.data.indeterminate = false;
        }
        else if (noChildChecked) {
            node.data.checked = false;
            node.data.indeterminate = false;
        }
        else {
            node.data.checked = true;
            node.data.indeterminate = true;
        }
        this.updateLayerVisible(node.data.id, node.data.checked);
        this.updateParentNodeCheckbox(node.parent);
    };
    LegendComponent.prototype.updateLayerVisible = function (layerId, visible) {
        var layer = this.layerService.getEsriLayerByUniqueId(layerId);
        if (layer) {
            layer.visible = visible;
        }
    };
    LegendComponent.prototype.getMapLayerList = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.mapLayersSub = this.layerService.mapLayersSub.subscribe(function (layers) {
                    if (!layers) {
                        return;
                    }
                    _this.layerList = layers;
                    _this.refreshTree();
                });
                return [2 /*return*/];
            });
        });
    };
    LegendComponent.prototype.getLegendLayers = function () {
        return (this.layerService.mapRef.layers.toArray().filter(function (layer) { return layer.mapcoreProps && !layer.mapcoreProps.hideInLegend && !layer.mapcoreProps.groupParent && !(layer.listMode === 'hide'); })).slice().reverse();
    };
    LegendComponent.prototype.createLeafNode = function (layer, parentNode) {
        var mapcoreProps = layer.mapcoreProps;
        var tempLayer;
        if (layer.type === 'map-image') {
            tempLayer = layer.sublayers.getItemAt(0);
        }
        else {
            tempLayer = layer;
        }
        var leafNode = {
            checked: layer.visible,
            id: layer.id,
            mapcoreId: mapcoreProps.id,
            name: mapcoreProps.name,
            nodeType: 'leaf',
            hasDetails: true,
            showDetails: false,
            showBreakDetail: false,
            layerData: tempLayer
        };
        if ((layer.loadStatus === 'loading' || layer.loadStatus === 'not-loaded') && layer.type !== 'feature') {
            leafNode.loading = true;
        }
        if (layer.type === 'graphics') {
            leafNode.hasDetails = false;
        }
        if (!Array.isArray(parentNode)) {
            parentNode.children.push(leafNode);
        }
        else {
            parentNode.push(leafNode);
        }
    };
    LegendComponent.prototype.createGroupNode = function (groupData, visible) {
        var groupNode = {
            checked: visible,
            children: [],
            id: groupData.groupId,
            name: groupData.name,
            nodeType: 'group',
            isExpanded: groupData.isOpen
        };
        this.nodes.push(groupNode);
        return groupNode;
    };
    LegendComponent.prototype.addChildToGroup = function (layer, parentGroup) {
        this.createLeafNode(layer, parentGroup);
    };
    LegendComponent.prototype.setParentNodesCheckboxBasedOnChildren = function (nodes) {
        var e_8, _a;
        try {
            for (var nodes_1 = tslib_1.__values(nodes), nodes_1_1 = nodes_1.next(); !nodes_1_1.done; nodes_1_1 = nodes_1.next()) {
                var node = nodes_1_1.value;
                if (node.children) {
                    this.setParentNodesCheckboxBasedOnChildren(node.children);
                    node.checked = node.children.some(function (x) { return x.checked; });
                    node.indeterminate = node.checked && node.children.some(function (x) { return !x.checked; });
                }
            }
        }
        catch (e_8_1) { e_8 = { error: e_8_1 }; }
        finally {
            try {
                if (nodes_1_1 && !nodes_1_1.done && (_a = nodes_1.return)) _a.call(nodes_1);
            }
            finally { if (e_8) throw e_8.error; }
        }
    };
    LegendComponent.prototype.setExpanded = function () {
        var e_9, _a;
        if (this.legendTree && this.legendTree.treeModel) {
            var _loop_1 = function (node) {
                var groupRoot = this_1.legendTree.treeModel.roots.find(function (root) { return root.id === node.id; });
                if (groupRoot) {
                    groupRoot.expand();
                }
            };
            var this_1 = this;
            try {
                for (var _b = tslib_1.__values(this.legendTree.treeModel.nodes.filter(function (n) { return n.nodeType === 'group' && n.isExpanded; })), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var node = _c.value;
                    _loop_1(node);
                }
            }
            catch (e_9_1) { e_9 = { error: e_9_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_9) throw e_9.error; }
            }
        }
    };
    LegendComponent.prototype.toggleExpanded = function (e) {
        var e_10, _a;
        if (e.isExpanded) {
            this.triggerLayerNameUpdates();
        }
        var layer = this.layerService.getEsriLayerByUniqueId(e.node.data.id);
        if (layer && layer.mapcoreProps) {
            try {
                for (var _b = tslib_1.__values(layer.layers), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var childLayer = _c.value;
                    childLayer.mapcoreProps.groupParent.isOpen = e.isExpanded;
                }
            }
            catch (e_10_1) { e_10 = { error: e_10_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_10) throw e_10.error; }
            }
        }
    };
    LegendComponent.prototype.optionSelected = function (target, layerId) {
        this.optionSelectedEvent.emit({ target: target, layerId: layerId });
    };
    LegendComponent.prototype.groupOptionSelected = function (target, groupLayerId) {
        this.groupOptionSelectedEvent.emit({ target: target, groupLayerId: groupLayerId });
    };
    LegendComponent.prototype.ngOnDestroy = function () {
        if (this.mapViewReadySub) {
            this.mapViewReadySub.unsubscribe();
        }
        if (this.mapLayersSub) {
            this.mapLayersSub.unsubscribe();
        }
    };
    LegendComponent.prototype.layerNameChange = function (event, layerId) {
        var element = event.target;
        var updatedName = element.value;
        var layer = this.layerService.getEsriLayerByUniqueId(layerId);
        layer.mapcoreProps.name = updatedName;
        this.recalcuateRows(element);
        this.layerService.layersRefreshed.emit();
    };
    LegendComponent.prototype.recalcuateRows = function (textarea) {
        if (textarea.style.height) {
            return;
        } // Height was changed specifically, so don't recalculate
        textarea.setAttribute('rows', '1');
        while (textarea.scrollHeight > textarea.offsetHeight && parseFloat(textarea.getAttribute('rows')) < limitRows) {
            textarea.setAttribute('rows', (parseFloat(textarea.getAttribute('rows')) + 1).toString());
        }
    };
    LegendComponent.prototype.onSymbolChange = function (event) {
        this.onsymbolchange.emit(event);
    };
    LegendComponent.prototype.getNodeByESRIId = function (id, baseNode) {
        var e_11, _a;
        var retVal;
        var nodes = this.nodes;
        if (baseNode) {
            nodes = baseNode.children || [];
        }
        try {
            for (var nodes_2 = tslib_1.__values(nodes), nodes_2_1 = nodes_2.next(); !nodes_2_1.done; nodes_2_1 = nodes_2.next()) {
                var node = nodes_2_1.value;
                if (node.nodeType === 'group') {
                    retVal = this.getNodeByESRIId(id, node);
                }
                else if (node.id === id) {
                    retVal = node;
                    break;
                }
            }
        }
        catch (e_11_1) { e_11 = { error: e_11_1 }; }
        finally {
            try {
                if (nodes_2_1 && !nodes_2_1.done && (_a = nodes_2.return)) _a.call(nodes_2);
            }
            finally { if (e_11) throw e_11.error; }
        }
        return retVal;
    };
    LegendComponent.prototype.getElementByIdWithShadowRoots = function (id) {
        var e_12, _a;
        // Check the main document first
        var element = document.getElementById(id);
        if (element) {
            return element;
        }
        // If not found in the main document, search through all shadow roots in the document
        var shadowHosts = Array.from(document.querySelectorAll('mc-legend')); // Adjust with correct selector
        try {
            for (var shadowHosts_1 = tslib_1.__values(shadowHosts), shadowHosts_1_1 = shadowHosts_1.next(); !shadowHosts_1_1.done; shadowHosts_1_1 = shadowHosts_1.next()) {
                var host = shadowHosts_1_1.value;
                if (host.shadowRoot) {
                    // Search within the shadow root
                    var foundElement = host.shadowRoot.querySelector("#" + id);
                    if (foundElement) {
                        return foundElement;
                    }
                }
            }
        }
        catch (e_12_1) { e_12 = { error: e_12_1 }; }
        finally {
            try {
                if (shadowHosts_1_1 && !shadowHosts_1_1.done && (_a = shadowHosts_1.return)) _a.call(shadowHosts_1);
            }
            finally { if (e_12) throw e_12.error; }
        }
        return null;
    };
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], LegendComponent.prototype, "showLayerDetail", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], LegendComponent.prototype, "readonly", void 0);
    return LegendComponent;
}(BaseComponent));
export { LegendComponent };
